import createIcon from '../../createIcon';

/**
 * @component @name Dining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIgMi45IDIgNFYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xMSAxMC4zQzExIDExLjIzIDEwLjM2IDEyLjAxIDkuNSAxMi4yM1YxOUg4VjEyLjIzQzcuMTQgMTIuMDEgNi41IDExLjIzIDYuNSAxMC4zVjYuNUM2LjUgNi4yMiA2LjcyIDYgNyA2QzcuMjggNiA3LjUgNi4yMiA3LjUgNi41VjlIOC4yNVY2LjVDOC4yNSA2LjIyIDguNDcgNiA4Ljc1IDZDOS4wMyA2IDkuMjUgNi4yMiA5LjI1IDYuNVY5SDEwVjYuNUMxMCA2LjIyIDEwLjIzIDYgMTAuNSA2QzEwLjc4IDYgMTEgNi4yMiAxMSA2LjVWMTAuM1pNMTUuNTggMTIuNTlMMTUuNSAxMi42MlYxOUgxNFYxMi42MkwxMy45MiAxMi41OEMxMi45NSAxMi4xMSAxMi4yNSAxMC44OCAxMi4yNSA5LjRDMTIuMjUgNy41MiAxMy4zOCA2IDE0Ljc1IDZDMTYuMTMgNiAxNy4yNSA3LjUzIDE3LjI1IDkuNDFDMTcuMjUgMTAuODkgMTYuNTUgMTIuMTIgMTUuNTggMTIuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dining = createIcon('Dining', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM11 10.3C11 11.23 10.36 12.01 9.5 12.23V19H8V12.23C7.14 12.01 6.5 11.23 6.5 10.3V6.5C6.5 6.22 6.72 6 7 6C7.28 6 7.5 6.22 7.5 6.5V9H8.25V6.5C8.25 6.22 8.47 6 8.75 6C9.03 6 9.25 6.22 9.25 6.5V9H10V6.5C10 6.22 10.23 6 10.5 6C10.78 6 11 6.22 11 6.5V10.3ZM15.58 12.59L15.5 12.62V19H14V12.62L13.92 12.58C12.95 12.11 12.25 10.88 12.25 9.4C12.25 7.52 13.38 6 14.75 6C16.13 6 17.25 7.53 17.25 9.41C17.25 10.89 16.55 12.12 15.58 12.59Z',
      key: '1vh2hg',
    },
  ],
]);

export default Dining;
